import { getApp, getApps, initializeApp, type FirebaseOptions } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';

const localFirebaseConfig: FirebaseOptions = {
  apiKey: 'demo-api-key',
  authDomain: 'demo-intellium.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'demo-intellium',
  appId: 'demo-app',
};

const productionFirebaseConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!import.meta.env.DEV) {
  const missingValues = Object.entries(productionFirebaseConfig)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missingValues.length > 0) {
    throw new Error(`Missing Firebase configuration: ${missingValues.join(', ')}`);
  }
}

export const firebaseApp = getApps().length > 0
  ? getApp()
  : initializeApp(import.meta.env.DEV ? localFirebaseConfig : productionFirebaseConfig);

export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);

if (import.meta.env.DEV) {
  const emulatorHost = import.meta.env.VITE_FIRESTORE_EMULATOR_HOST ?? '127.0.0.1';
  const emulatorPort = Number(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT ?? 8181);
  const authEmulatorHost = import.meta.env.VITE_AUTH_EMULATOR_HOST ?? '127.0.0.1';
  const authEmulatorPort = Number(import.meta.env.VITE_AUTH_EMULATOR_PORT ?? 9099);
  const connectionState = globalThis as typeof globalThis & {
    __intelliumFirestoreEmulatorConnected?: boolean;
    __intelliumAuthEmulatorConnected?: boolean;
  };

  if (!connectionState.__intelliumFirestoreEmulatorConnected) {
    connectFirestoreEmulator(db, emulatorHost, emulatorPort);
    connectionState.__intelliumFirestoreEmulatorConnected = true;
  }

  if (!connectionState.__intelliumAuthEmulatorConnected) {
    connectAuthEmulator(auth, `http://${authEmulatorHost}:${authEmulatorPort}`, {
      disableWarnings: true,
    });
    connectionState.__intelliumAuthEmulatorConnected = true;
  }
}